import get from 'lodash.get';
import flatten from 'lodash.flatten';
import values from 'lodash.values';

const MAX_FORMS_USED = 3;

/**
 * Counts how many times form was used in student results
 * @param {string} formId of current form
 * @param {object} studentResults collects all results of current studen
 * @returns {number} times form was used in array with student results
 */
export const timesFormWasUsedInResults = (formId, studentResults) =>
    Math.min(
        Object.keys(studentResults).reduce((acc, period) => {
            const resultsByPeriod = get(studentResults, period);
            const numOfForms = resultsByPeriod.reduce(
                (formsNum, result) => (formId === get(result, 'formUid') ? formsNum + 1 : formsNum),
                0,
            );
            return acc + numOfForms;
        }, 0),
        MAX_FORMS_USED,
    );

export const timesFormBurstWasUsedInResults = (formId, studentResults) =>
    Math.min(
        Object.keys(studentResults).reduce((acc, period) => {
            const resultsByPeriod = get(studentResults, period);
            const results = resultsByPeriod.map(result => get(result, 'results'));
            const numOfForms = flatten(values(results)).reduce(
                (formsNum, result) =>
                    formId === parseInt(get(result, 'probeId'), 10) ? formsNum + 1 : formsNum,
                0,
            );
            return acc + numOfForms;
        }, 0),
        MAX_FORMS_USED,
    );
